import type { QuoteRequestStatus } from '@repo/api-contracts';

/**
 * 운영자 조작이 허용되는 상태(견적 설계 §6, 서버 quote-policy 와 같은 집합).
 * 화면은 이 결과로 편집기·버튼·폼을 보이거나 숨기고, 최종 판정은 서버가 한다(CONFLICT).
 */
const DRAFT_EDITABLE: readonly QuoteRequestStatus[] = [
  'REQUESTED',
  'ISSUED',
  'REVISION_REQUESTED',
  'EXPIRED',
];
const REISSUABLE: readonly QuoteRequestStatus[] = ['ISSUED', 'REVISION_REQUESTED', 'EXPIRED'];
const REJECTABLE: readonly QuoteRequestStatus[] = [
  'REQUESTED',
  'ISSUED',
  'REVISION_REQUESTED',
  'EXPIRED',
];

/** 초안 편집·임시 저장·발행(§6-3·6-4). ORDERED 와 끝난 상태는 편집하지 않는다. */
export const canEditQuoteDraft = (status: QuoteRequestStatus): boolean =>
  DRAFT_EDITABLE.includes(status);

/** 재발행 초안 만들기(§6-5). */
export const canCreateQuoteRevisionDraft = (status: QuoteRequestStatus): boolean =>
  REISSUABLE.includes(status);

/** 반려(§6-6). 주문됨은 관리자 조작을 거부한다. */
export const canRejectQuote = (status: QuoteRequestStatus): boolean => REJECTABLE.includes(status);
